export default "__VITE_ASSET__CF9el084__"